import { render, staticRenderFns } from "./ManterGrupoView.vue?vue&type=template&id=768bed66"
import script from "./ManterGrupoView.vue?vue&type=script&lang=js"
export * from "./ManterGrupoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports